import { IntlShape, useIntl } from 'gatsby-plugin-intl';
import { Location } from '../types/location';
import React from 'react'
import {COMMON_MESSAGES} from '../intl/messages'
export const filterObject = (a, condition = a => !a) => {
  const b = {}
  for (const [key, value] of Object.entries(a)) {
    if (condition(value)) continue
    b[key] = value
  }
  return b
}

export const swapItinerary = (values, setter) => {
  const { src, src_id, src_code, dest, dest_id, dest_code } = values
  setter("src", dest)
  setter("dest", src)
  setter("src_id", dest_id)
  setter("dest_id", src_id)
  setter("src_code", dest_code)
  setter("dest_code", src_code)
}

export const getCountryFromCode = (countryCode: string, countries: any[]) => {
  if (countries) {
    const a = countries.filter(item => item.key == countryCode)
    return a?.[0]?.value
  }

  return countryCode
}

export const trimCityEmpty = city => {
  if (city?.length) return city + ", "
  return ""
}

export const tripCityAnywhere = city => {
  if (city?.length) return city
  return "Anywhere"
}


export const TranslatedCountry = (city:Location)=>{
  const intl = useIntl()
  switch(intl.locale){
    case "en":
      return city.country
    case "es":
      return city.translations_country.es
    case "pt":
      return city.translations_country.pt
    case "ru":
      return city.translations_country.ru
    default:
      return city.country
  }
}

const translateCity = (location,locale)=>{
  switch(locale){
    case "en":
      return location.city
    case "es":
      return location.translations.es
    case "pt":
      return location.translations.pt
    case "ru":
      return location.translations.ru
    default:
      return location.city
  }
}
const translateCountry = (location,locale)=>{
  switch(locale){
    case "en":
      return location.country
    case "es":
      return location.translations_country.es
    case "pt":
      return location.translations_country.pt
    case "ru":
      return location.translations_country.ru
    default:
      return location.country
  }
}
export const TranslateLocation = ({location,anywhere=false}:{location:Location,anywhere:boolean})=>{  
  const intl = useIntl()
  return (<span>
    {`${translateCity(location,intl.locale)?translateCity(location,intl.locale)+", ":anywhere?intl.formatMessage(COMMON_MESSAGES.anywhere)+", ":""} ${translateCountry(location,intl.locale)}`}
  </span>)
}



export const REGEX_PRICE = RegExp(/-?\d+(?:,\d{3})*(?:\.\d+)?/)